// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"b336ba9606234d528d95","339":"f2c83d72ee03220a14e3"}[chunkId] + ".js";
};